module.exports = __webpack_public_path__ + "img/05.e245103b.png";